import { useState } from "react";

const useEditMode = () => {
  const [isEditMode, setEditMode] = useState(false);

  return { isEditMode, handleEditModeChange: setEditMode };
};

export default useEditMode;
